import { ConfigStore } from '@/shared/model/store';
import { create } from 'ipfs-http-client';
import axios from "axios";

export const getIpfsClient = () => {
   const localGateway = ConfigStore.getState().localGateway
  
  try {
    const url = new URL(localGateway.url);
    return create({
      host: url.hostname,
      port: Number(url.port || (url.protocol === 'https:' ? 443 : 80)),
      protocol: url.protocol.replace(':', ''),
    });
  } catch (error) {
    console.error('Invalid IPFS configuration URL:', localGateway.url);
    throw new Error('Invalid IPFS configuration');
  }
};

export const checkIpfsConnection = async () => {
  const ipfs = getIpfsClient();
  
  try {
    const version = await ipfs.version();
    return {
      connected: true,
      version: version.version,
    };
  } catch (error) {
    return {
      connected: false,
      error: error.message,
    };
  }
};

export const uploadFileToIPFS = async (file) => {
    const ipfs = getIpfsClient()
    try {
        const check = await checkIpfsConnection()
        if(!check.connected) {
            return  
        }
        const added = await ipfs.add(file);
        await ipfs.pin.add(added.cid);
        return added.cid.toString();
    } catch (error) {
        console.error('Error uploading file to IPFS:', error);
        throw error;
    }
};

const instanceFilebase  = () => {
  const publicGateways = ConfigStore.getState().publicGateways
  const authToken = publicGateways.gateways[0]?.secret || ''
  const request = axios.create({
          headers: {
                  'Content-type': 'application/json',
                  'Accept': 'application/json',
                  'Authorization': `Bearer ${authToken}`,
              },
      })
  return request
}


export const pinToFilebase = async (cid) => {
      try {
      const request = instanceFilebase()
      const response = await request.post(`https://api.filebase.io/v1/ipfs/pins`, {
          cid: cid,
          name: `pinned-${Date.now()}`
        });
  
      return {
          success: true,
          data: response.data
      };
    } catch (error: any) {
       return {
          success: false,
          data: error.response.data.error
      };
    }
};

export const checkFilebasePin = async (cid) => {
  const request = instanceFilebase()
  try {
    const response = await request.get(`https://api.filebase.io/v1/ipfs/pins/${cid}`)
    return {
          success: true,
          data: response.data
      };
  } catch (error) {
    return {
          success: false,
          data: error.response.data.error
      };
  }

};